import { z } from 'zod';
import { Locale } from './enums';

/** POST /prereg — the website's sign-up to hear when the game launches (and get its launch gift). */
export const PreregRequest = z.object({
  email: z.string().trim().toLowerCase().email().max(254),
  locale: Locale.default('zh-HK'),
  /** Where the visitor came from (`?ref=` on the page), e.g. threads-03 or share. */
  ref: z.string().regex(/^[a-z0-9_-]{1,32}$/).optional(),
});
export type PreregRequest = z.input<typeof PreregRequest>;

/** GET /legal/:page/doc — a legal page as content, for the website to lay out in its own style. */
export const LegalDoc = z.object({
  title: z.string(),
  updated: z.string(),
  sections: z.array(z.object({ h: z.string(), p: z.array(z.string()) })),
  supportEmail: z.string(),
});
export type LegalDoc = z.infer<typeof LegalDoc>;
